import classNames from 'classnames'
import TextareaAutosize from 'react-textarea-autosize'

import styles from './index.module.css'

interface Props {
  className?: string
  maxRows?: number
  rows?: number
  [props: string]: any
}

const Textarea = ({ className, maxRows = 10, rows = 3, ...props }: Props) => (
  <TextareaAutosize
    {...props}
    className={classNames(styles.textarea, className)}
    maxRows={maxRows}
    minRows={rows}
  />
)

export default Textarea
